// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-G":"G_dpu-detail-G__qF1in"};